import React, { forwardRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import Select from "react-select";

import {
  OuterContainer,
  InnerContainer,
  TextInputField,
  DropdownField,
  TextareaField,
  TextareaContainer,
} from "./styles";

const DraftFields = forwardRef(
  (
    {
      type,
      name,
      placeholder,
      defaultValue,
      options = [],
      onChange,
      formatContent,
      contentType,
      onFocus,
      onBlur,
      ...rest
    },
    ref
  ) => {
    const {
      control,
      formState: { errors },
    } = useFormContext();

    const renderDropdownField = () => (
      <OuterContainer>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => (
            <Select
              {...field}
              onChange={(e) => {
                field.onChange(e);
                onChange(e);
              }}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.description}
              options={options}
              styles={DropdownField}
              {...rest}
            />
          )}
        />
      </OuterContainer>
    );

    const renderTextareaField = () => (
      <TextareaContainer>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => (
            <TextareaField
              {...field}
              hasError={errors[name]}
              ref={ref}
              onChange={(e) => {
                field.onChange(e);
                if (onChange) onChange(e);
              }}
              onFocus={(e) => {
                if (field.onFocus) field.onFocus(e);
                if (onFocus) onFocus(e);
              }}
              onBlur={(e) => {
                if (field.onBlur) field.onBlur(e);
                if (onBlur) onBlur(e);
              }}
              {...rest}
            />
          )}
        />
      </TextareaContainer>
    );

    const renderTextField = () => (
      <OuterContainer>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => (
            <InnerContainer>
              <TextInputField
                {...field}
                placeholder={placeholder}
                hasError={errors[name]}
                {...rest}
              />
              {errors[name] && <span>{errors[name].message}</span>}{" "}
            </InnerContainer>
          )}
        />
      </OuterContainer>
    );

    switch (type) {
      case "DROPDOWN":
        return renderDropdownField();
      case "TEXTAREA":
        return renderTextareaField();
      case "TEXT":
      default:
        return renderTextField();
    }
  }
);

export default DraftFields;
